var map = {
	"./2020_November.jpg": [
		46306,
		46306
	],
	"./2020_November_two.jpg": [
		28917,
		28917
	],
	"./Bells.mp4": [
		86330,
		86330
	],
	"./Bells2.mp4": [
		79874,
		79874
	],
	"./Berta_2023.jpg": [
		39853,
		39853
	],
	"./COVER.jpg": [
		91374,
		91374
	],
	"./COVER2.jpg": [
		8966,
		8966
	],
	"./California1.jpg": [
		48212,
		48212
	],
	"./California2.jpg": [
		77923,
		77923
	],
	"./Cats1.jpg": [
		3543,
		3543
	],
	"./Cats2.jpg": [
		92616,
		92616
	],
	"./Cats3.jpg": [
		36581,
		36581
	],
	"./Cats4.jpg": [
		89246,
		89246
	],
	"./Cats5.jpg": [
		74203,
		74203
	],
	"./Cats6.jpg": [
		13580,
		13580
	],
	"./Cats7.jpg": [
		68841,
		68841
	],
	"./Cats8.jpg": [
		98034,
		98034
	],
	"./CityGirl.jpg": [
		7864,
		7864
	],
	"./CityGirl.png": [
		90908,
		90908
	],
	"./CityGirl2.jpg": [
		21616,
		21616
	],
	"./CityGirl2.png": [
		59188,
		59188
	],
	"./CityGirl3.jpg": [
		82861,
		82861
	],
	"./CustomCat.jpg": [
		68304,
		68304
	],
	"./CustomCat.png": [
		82580,
		82580
	],
	"./Dancers.mp4": [
		25540,
		25540
	],
	"./Emergence1.jpg": [
		72755,
		72755
	],
	"./Emergence2.jpg": [
		37476,
		37476
	],
	"./Emergence3.jpg": [
		15521,
		15521
	],
	"./Emergence4.jpg": [
		47506,
		47506
	],
	"./Emergence5.jpg": [
		15439,
		15439
	],
	"./Emergence6.jpg": [
		1824,
		1824
	],
	"./Emergence7.jpg": [
		57405,
		57405
	],
	"./FashionGirl1.jpg": [
		36352,
		36352
	],
	"./FashionGirl1.png": [
		88740,
		88740
	],
	"./FashionGirl2.jpg": [
		19343,
		19343
	],
	"./FashionGirl2.png": [
		43391,
		43391
	],
	"./February_misc_1.jpg": [
		4086,
		4086
	],
	"./February_misc_2.jpg": [
		93665,
		93665
	],
	"./February_misc_3.jpg": [
		15620,
		15620
	],
	"./February_misc_4.jpg": [
		9935,
		9935
	],
	"./FishStory1.jpg": [
		91733,
		91733
	],
	"./FishStory2.jpg": [
		24394,
		24394
	],
	"./FishStory3.jpg": [
		63399,
		63399
	],
	"./FishStory4.jpg": [
		39612,
		39612
	],
	"./FishStory5.jpg": [
		36985,
		36985
	],
	"./Folded_vessel_1.jpg": [
		16200,
		16200
	],
	"./Folded_vessel_2.jpg": [
		27127,
		27127
	],
	"./Folded_vessel_3.jpg": [
		55962,
		33581
	],
	"./Folded_vessel_4.jpg": [
		92425,
		92425
	],
	"./Georgia_2006.jpg": [
		17424,
		17424
	],
	"./Girl1.jpg": [
		43620,
		43620
	],
	"./Girl2.jpg": [
		21427,
		21427
	],
	"./Girl3.jpg": [
		34966,
		34966
	],
	"./Girl4.jpg": [
		6077,
		6077
	],
	"./Girl5.jpg": [
		54944,
		54944
	],
	"./HoldingSteady1.jpg": [
		32967,
		32967
	],
	"./HoldingSteady2.jpg": [
		70392,
		70392
	],
	"./HoldingSteady3.jpg": [
		61301,
		61301
	],
	"./HoldingSteady4.jpg": [
		50414,
		50414
	],
	"./HoldingSteady5.jpg": [
		76875,
		76875
	],
	"./IMG_0964.jpg": [
		44188,
		44188
	],
	"./IMG_0965.jpg": [
		14713,
		14713
	],
	"./IMG_0967.jpg": [
		12491,
		12491
	],
	"./IMG_0968.jpg": [
		4560,
		4560
	],
	"./IMG_0974.jpg": [
		63067,
		63067
	],
	"./IMG_0975.jpg": [
		31582,
		31582
	],
	"./Man1.jpg": [
		91386,
		91386
	],
	"./Man1.mp4": [
		55027,
		55027
	],
	"./Man2.jpg": [
		95589,
		95589
	],
	"./Myth1.jpg": [
		58112,
		58112
	],
	"./Myth2.jpg": [
		24751,
		24751
	],
	"./Myth3.jpg": [
		48370,
		48370
	],
	"./Myth4.jpg": [
		76417,
		76417
	],
	"./Myth5.jpg": [
		98372,
		98372
	],
	"./Myth6.jpg": [
		82067,
		82067
	],
	"./Myth7.jpg": [
		26806,
		26806
	],
	"./Nestled_Thoughts.mp4": [
		88924,
		88924
	],
	"./Nestled_Thoughts1.jpg": [
		37544,
		37544
	],
	"./PXL_20210307.PORTRAIT.jpg": [
		57058,
		57058
	],
	"./PXL_20241009_173312640.jpg": [
		64084,
		64084
	],
	"./PXL_20241009_173400157.jpg": [
		18605,
		18605
	],
	"./PXL_20241009_173451722.jpg": [
		32209,
		32209
	],
	"./PXL_20241009_173504653.jpg": [
		1793,
		1793
	],
	"./PXL_20250426_195931697.PORTRAIT.jpg": [
		54463,
		54463
	],
	"./Protect_1.jpg": [
		13926,
		13926
	],
	"./Protect_2.jpg": [
		71697,
		71697
	],
	"./Protect_3.jpg": [
		93172,
		93172
	],
	"./Protect_4.jpg": [
		95135,
		95135
	],
	"./Provance.jpg": [
		99651,
		99651
	],
	"./Rotorua.jpg": [
		3985,
		3985
	],
	"./ScalingLife1.jpg": [
		15021,
		15021
	],
	"./ScalingLife2.jpg": [
		85762,
		85762
	],
	"./ScalingLife3.jpg": [
		98431,
		98431
	],
	"./ScalingLife4.jpg": [
		77620,
		77620
	],
	"./ScalingLife5.jpg": [
		74993,
		74993
	],
	"./ScalingLife6.jpg": [
		17222,
		17222
	],
	"./ScalingLife7.jpg": [
		55747,
		55747
	],
	"./Snake1.jpg": [
		83174,
		83174
	],
	"./Snake2.jpg": [
		40945,
		40945
	],
	"./Snake3.jpg": [
		62420,
		62420
	],
	"./Snake4.jpg": [
		48031,
		48031
	],
	"./Snake5.jpg": [
		28034,
		28034
	],
	"./Split1.jpg": [
		70950,
		48569
	],
	"./Split10.jpg": [
		38940,
		38940
	],
	"./Split2.jpg": [
		3153,
		3153
	],
	"./Split3.jpg": [
		31348,
		8967
	],
	"./Split4.jpg": [
		9631,
		9631
	],
	"./Split5.jpg": [
		17922,
		17922
	],
	"./Split6.jpg": [
		87149,
		87149
	],
	"./Split7.jpg": [
		42256,
		19875
	],
	"./Split8.jpg": [
		66539,
		66539
	],
	"./Split9.jpg": [
		72142,
		72142
	],
	"./Stage.jpg": [
		38041,
		38041
	],
	"./Steampunk 1.2.jpg": [
		27090,
		27090
	],
	"./Steampunk 1.6.jpg": [
		5526,
		5526
	],
	"./Steampunk 1.7.jpg": [
		60787,
		60787
	],
	"./Steampunk_1.10.jpg": [
		858,
		858
	],
	"./Steampunk_1.2.jpg": [
		24591,
		24591
	],
	"./Steampunk_1.3.jpg": [
		52210,
		52210
	],
	"./Steampunk_1.4.jpg": [
		77697,
		77697
	],
	"./Steampunk_1.6.jpg": [
		93811,
		93811
	],
	"./Steampunk_1.7.jpg": [
		7350,
		7350
	],
	"./Steampunk_1.8.jpg": [
		32837,
		32837
	],
	"./Steampunk_1.9.jpg": [
		89320,
		89320
	],
	"./StoryKeeper1.jpg": [
		19541,
		19541
	],
	"./StoryKeeper2.jpg": [
		52202,
		52202
	],
	"./StoryKeeper3.jpg": [
		91207,
		91207
	],
	"./StoryKeeper4.jpg": [
		67420,
		67420
	],
	"./StoryKeeper5.jpg": [
		81145,
		81145
	],
	"./StoryKeeper6.jpg": [
		8654,
		8654
	],
	"./Tartu.jpg": [
		17255,
		17255
	],
	"./The_Catch_1.jpg": [
		39738,
		39738
	],
	"./The_Catch_2.jpg": [
		62341,
		62341
	],
	"./The_Readers_Pause.jpg": [
		74948,
		74948
	],
	"./The_Readers_Pause.png": [
		25632,
		25632
	],
	"./Thea.jpg": [
		47401,
		47401
	],
	"./TinyCat1.jpg": [
		57036,
		57036
	],
	"./TinyCat2.jpg": [
		99835,
		99835
	],
	"./TinyCat3.jpg": [
		51998,
		51998
	],
	"./TinyMouse1.jpg": [
		2423,
		2423
	],
	"./TinyMouse2.jpg": [
		91496,
		91496
	],
	"./TinyMouse3.jpg": [
		19109,
		19109
	],
	"./TinyTale1.jpg": [
		53284,
		53284
	],
	"./TinyTale1.png": [
		75680,
		75680
	],
	"./TinyTale2.jpg": [
		79507,
		79507
	],
	"./TinyTale2.png": [
		73243,
		73243
	],
	"./TinyTale3.jpg": [
		51094,
		51094
	],
	"./TinyTale3.png": [
		51698,
		51698
	],
	"./TinyTale4.jpg": [
		57437,
		57437
	],
	"./TinyTale4.png": [
		81677,
		81677
	],
	"./TinyTale5.jpg": [
		89344,
		89344
	],
	"./TinyTale5.png": [
		18436,
		18436
	],
	"./TinyTale6.jpg": [
		79663,
		79663
	],
	"./TinyTale6.png": [
		3711,
		3711
	],
	"./TinyTale7.jpg": [
		3282,
		3282
	],
	"./TinyTale7.png": [
		49910,
		49910
	],
	"./TinyTale8.jpg": [
		85993,
		85993
	],
	"./TinyTale8.png": [
		88689,
		88689
	],
	"./Tits_Up1.jpg": [
		70896,
		70896
	],
	"./Tits_Up2.jpg": [
		38271,
		38271
	],
	"./Tits_Up3.jpg": [
		46562,
		46562
	],
	"./Tits_Up4.jpg": [
		31793,
		31793
	],
	"./Tits_Up5.jpg": [
		59988,
		59988
	],
	"./Transition.jpg": [
		26958,
		26958
	],
	"./Two-faced1.jpg": [
		68454,
		68454
	],
	"./Two-faced2.jpg": [
		84305,
		84305
	],
	"./Two-faced3.jpg": [
		12500,
		12500
	],
	"./Two-faced4.jpg": [
		7135,
		7135
	],
	"./Two-faced5.jpg": [
		99074,
		99074
	],
	"./Two-faced6.jpg": [
		68301,
		68301
	],
	"./Two-faced7.jpg": [
		23408,
		23408
	],
	"./Two-faced8.jpg": [
		47691,
		47691
	],
	"./Two-faced9.jpg": [
		69646,
		69646
	],
	"./Two_2006.jpg": [
		46518,
		46518
	],
	"./Voice1.jpg": [
		36756,
		36756
	],
	"./Voice2.jpg": [
		66467,
		66467
	],
	"./Voice3.jpg": [
		76358,
		76358
	],
	"./Voice4.jpg": [
		92557,
		92557
	],
	"./Voice5.jpg": [
		47664,
		47664
	],
	"./Voice6.jpg": [
		15039,
		15039
	],
	"./Voice7.jpg": [
		23330,
		23330
	],
	"./Yellowstone.jpg": [
		35968,
		35968
	],
	"./asparagus.jpg": [
		38366,
		38366
	],
	"./bells1.jpg": [
		70952,
		70952
	],
	"./bells2.jpg": [
		39351,
		39351
	],
	"./bells3.jpg": [
		75514,
		75514
	],
	"./bells4.jpg": [
		96201,
		96201
	],
	"./bells5.jpg": [
		58156,
		58156
	],
	"./birdPlate_1.jpg": [
		27696,
		27696
	],
	"./birdPlate_2.jpg": [
		12031,
		12031
	],
	"./birdPlate_3.jpg": [
		99362,
		99362
	],
	"./bird_1.png": [
		42182,
		42182
	],
	"./bird_2.png": [
		83421,
		83421
	],
	"./bird_3.png": [
		62292,
		62292
	],
	"./bird_4.png": [
		8203,
		8203
	],
	"./blue_2020.jpg": [
		78764,
		78764
	],
	"./blue_2020.png": [
		4680,
		4680
	],
	"./body4.jpg": [
		12667,
		12667
	],
	"./candleholder_1.jpg": [
		67798,
		67798
	],
	"./candleholder_2.jpg": [
		57377,
		57377
	],
	"./conversation_1.jpg": [
		18094,
		18094
	],
	"./conversation_2.jpg": [
		16761,
		16761
	],
	"./conversation_3.jpg": [
		72412,
		72412
	],
	"./conversation_4.jpg": [
		26823,
		26823
	],
	"./email_at.jpg": [
		89683,
		89683
	],
	"./email_at.png": [
		67067,
		67067
	],
	"./fish.jpg": [
		68357,
		68357
	],
	"./fish_tray_1.jpg": [
		81154,
		81154
	],
	"./fish_tray_2.jpg": [
		10413,
		10413
	],
	"./full/2020_November.jpg": [
		66924,
		66924
	],
	"./full/2020_November_two.jpg": [
		44139,
		44139
	],
	"./full/Berta_2023.jpg": [
		75787,
		75787
	],
	"./full/COVER.jpg": [
		60832,
		60832
	],
	"./full/COVER2.jpg": [
		17192,
		17192
	],
	"./full/California1.jpg": [
		92658,
		92658
	],
	"./full/California2.jpg": [
		11613,
		11613
	],
	"./full/Cats1.jpg": [
		17249,
		17249
	],
	"./full/Cats2.jpg": [
		67638,
		67638
	],
	"./full/Cats3.jpg": [
		39251,
		39251
	],
	"./full/Cats4.jpg": [
		98944,
		98944
	],
	"./full/Cats5.jpg": [
		24509,
		24509
	],
	"./full/Cats6.jpg": [
		89202,
		89202
	],
	"./full/Cats7.jpg": [
		65583,
		65583
	],
	"./full/Cats8.jpg": [
		4748,
		4748
	],
	"./full/CityGirl.jpg": [
		47914,
		47914
	],
	"./full/CityGirl2.jpg": [
		71578,
		71578
	],
	"./full/CityGirl3.jpg": [
		59095,
		59095
	],
	"./full/CustomCat.jpg": [
		83410,
		83410
	],
	"./full/Emergence1.jpg": [
		22281,
		22281
	],
	"./full/Emergence2.jpg": [
		95550,
		95550
	],
	"./full/Emergence3.jpg": [
		27035,
		27035
	],
	"./full/Emergence4.jpg": [
		97032,
		97032
	],
	"./full/Emergence5.jpg": [
		24197,
		24197
	],
	"./full/Emergence6.jpg": [
		17946,
		17946
	],
	"./full/Emergence7.jpg": [
		65431,
		65431
	],
	"./full/FashionGirl1.jpg": [
		24166,
		24166
	],
	"./full/FashionGirl2.jpg": [
		51921,
		51921
	],
	"./full/February_misc_1.jpg": [
		60912,
		60912
	],
	"./full/February_misc_2.jpg": [
		75871,
		75871
	],
	"./full/February_misc_3.jpg": [
		55874,
		55874
	],
	"./full/February_misc_4.jpg": [
		52433,
		52433
	],
	"./full/FishStory1.jpg": [
		40423,
		40423
	],
	"./full/FishStory2.jpg": [
		86616,
		86616
	],
	"./full/FishStory3.jpg": [
		94485,
		94485
	],
	"./full/FishStory4.jpg": [
		48366,
		48366
	],
	"./full/FishStory5.jpg": [
		26411,
		26411
	],
	"./full/Folded_vessel_1.jpg": [
		70582,
		70582
	],
	"./full/Folded_vessel_2.jpg": [
		62721,
		62721
	],
	"./full/Folded_vessel_3.jpg": [
		72772,
		72772
	],
	"./full/Folded_vessel_4.jpg": [
		15503,
		15503
	],
	"./full/Georgia_2006.jpg": [
		83106,
		83106
	],
	"./full/Girl1.jpg": [
		22814,
		22814
	],
	"./full/Girl2.jpg": [
		2409,
		2409
	],
	"./full/Girl3.jpg": [
		47148,
		47148
	],
	"./full/Girl4.jpg": [
		53463,
		53463
	],
	"./full/Girl5.jpg": [
		65946,
		65946
	],
	"./full/HoldingSteady1.jpg": [
		79549,
		79549
	],
	"./full/HoldingSteady2.jpg": [
		69650,
		69650
	],
	"./full/HoldingSteady3.jpg": [
		53935,
		53935
	],
	"./full/HoldingSteady4.jpg": [
		59620,
		59620
	],
	"./full/HoldingSteady5.jpg": [
		37665,
		37665
	],
	"./full/IMG_0964.jpg": [
		95982,
		95982
	],
	"./full/IMG_0965.jpg": [
		74027,
		74027
	],
	"./full/IMG_0967.jpg": [
		3097,
		3097
	],
	"./full/IMG_0968.jpg": [
		48706,
		48706
	],
	"./full/IMG_0974.jpg": [
		24861,
		24861
	],
	"./full/IMG_0975.jpg": [
		69280,
		69280
	],
	"./full/Man1.jpg": [
		52404,
		52404
	],
	"./full/Man2.jpg": [
		54211,
		54211
	],
	"./full/Myth1.jpg": [
		81178,
		81178
	],
	"./full/Myth2.jpg": [
		38405,
		38405
	],
	"./full/Myth3.jpg": [
		10792,
		10792
	],
	"./full/Myth4.jpg": [
		15675,
		15675
	],
	"./full/Myth5.jpg": [
		95518,
		95518
	],
	"./full/Myth6.jpg": [
		70665,
		70665
	],
	"./full/Myth7.jpg": [
		72876,
		72876
	],
	"./full/Nestled_Thoughts1.jpg": [
		70466,
		70466
	],
	"./full/PXL_20210307.PORTRAIT.jpg": [
		58784,
		58784
	],
	"./full/PXL_20241009_173312640.jpg": [
		23350,
		23350
	],
	"./full/PXL_20241009_173400157.jpg": [
		49263,
		49263
	],
	"./full/PXL_20241009_173451722.jpg": [
		73699,
		73699
	],
	"./full/PXL_20241009_173504653.jpg": [
		31487,
		31487
	],
	"./full/PXL_20250426_195931697.PORTRAIT.jpg": [
		29677,
		29677
	],
	"./full/Protect_1.jpg": [
		16432,
		16432
	],
	"./full/Protect_2.jpg": [
		767,
		767
	],
	"./full/Protect_3.jpg": [
		88098,
		88098
	],
	"./full/Protect_4.jpg": [
		77329,
		77329
	],
	"./full/Provance.jpg": [
		29541,
		29541
	],
	"./full/Rotorua.jpg": [
		52003,
		52003
	],
	"./full/ScalingLife1.jpg": [
		55207,
		55207
	],
	"./full/ScalingLife2.jpg": [
		22360,
		22360
	],
	"./full/ScalingLife3.jpg": [
		83541,
		83541
	],
	"./full/ScalingLife4.jpg": [
		30126,
		30126
	],
	"./full/ScalingLife5.jpg": [
		25963,
		25963
	],
	"./full/ScalingLife6.jpg": [
		796,
		796
	],
	"./full/ScalingLife7.jpg": [
		45145,
		45145
	],
	"./full/Snake1.jpg": [
		76080,
		76080
	],
	"./full/Snake2.jpg": [
		43455,
		43455
	],
	"./full/Snake3.jpg": [
		51746,
		51746
	],
	"./full/Snake4.jpg": [
		36977,
		36977
	],
	"./full/Snake5.jpg": [
		65172,
		65172
	],
	"./full/Split1.jpg": [
		360,
		360
	],
	"./full/Split10.jpg": [
		80402,
		80402
	],
	"./full/Split2.jpg": [
		68759,
		68759
	],
	"./full/Split3.jpg": [
		21274,
		21274
	],
	"./full/Split4.jpg": [
		41961,
		41961
	],
	"./full/Split5.jpg": [
		3916,
		3916
	],
	"./full/Split6.jpg": [
		30363,
		30363
	],
	"./full/Split7.jpg": [
		98878,
		98878
	],
	"./full/Split8.jpg": [
		73149,
		73149
	],
	"./full/Split9.jpg": [
		22016,
		22016
	],
	"./full/Stage.jpg": [
		81083,
		81083
	],
	"./full/Steampunk 1.2.jpg": [
		17912,
		17912
	],
	"./full/Steampunk 1.6.jpg": [
		79996,
		79996
	],
	"./full/Steampunk 1.7.jpg": [
		24345,
		24345
	],
	"./full/Steampunk_1.10.jpg": [
		74212,
		74212
	],
	"./full/Steampunk_1.2.jpg": [
		79561,
		79561
	],
	"./full/Steampunk_1.3.jpg": [
		17836,
		17836
	],
	"./full/Steampunk_1.4.jpg": [
		72183,
		72183
	],
	"./full/Steampunk_1.6.jpg": [
		325,
		325
	],
	"./full/Steampunk_1.7.jpg": [
		37960,
		37960
	],
	"./full/Steampunk_1.8.jpg": [
		26099,
		26099
	],
	"./full/Steampunk_1.9.jpg": [
		62934,
		62934
	],
	"./full/StoryKeeper1.jpg": [
		39479,
		39479
	],
	"./full/StoryKeeper2.jpg": [
		808,
		808
	],
	"./full/StoryKeeper3.jpg": [
		44773,
		44773
	],
	"./full/StoryKeeper4.jpg": [
		85534,
		85534
	],
	"./full/StoryKeeper5.jpg": [
		5691,
		5691
	],
	"./full/StoryKeeper6.jpg": [
		79244,
		79244
	],
	"./full/Tartu.jpg": [
		44557,
		44557
	],
	"./full/The_Catch_1.jpg": [
		12108,
		12108
	],
	"./full/The_Catch_2.jpg": [
		54907,
		54907
	],
	"./full/The_Readers_Pause.jpg": [
		5286,
		5286
	],
	"./full/Thea.jpg": [
		35479,
		35479
	],
	"./full/TinyCat1.jpg": [
		186,
		186
	],
	"./full/TinyCat2.jpg": [
		57413,
		57413
	],
	"./full/TinyCat3.jpg": [
		29800,
		29800
	],
	"./full/TinyMouse1.jpg": [
		94401,
		94401
	],
	"./full/TinyMouse2.jpg": [
		2262,
		2262
	],
	"./full/TinyMouse3.jpg": [
		47027,
		47027
	],
	"./full/TinyTale1.jpg": [
		99354,
		99354
	],
	"./full/TinyTale2.jpg": [
		3557,
		3557
	],
	"./full/TinyTale3.jpg": [
		59592,
		59592
	],
	"./full/TinyTale4.jpg": [
		41179,
		41179
	],
	"./full/TinyTale5.jpg": [
		56222,
		56222
	],
	"./full/TinyTale6.jpg": [
		35817,
		35817
	],
	"./full/TinyTale7.jpg": [
		80556,
		80556
	],
	"./full/TinyTale8.jpg": [
		41391,
		41391
	],
	"./full/Tits_Up1.jpg": [
		89982,
		89982
	],
	"./full/Tits_Up2.jpg": [
		16713,
		16713
	],
	"./full/Tits_Up3.jpg": [
		78668,
		78668
	],
	"./full/Tits_Up4.jpg": [
		59863,
		59863
	],
	"./full/Tits_Up5.jpg": [
		96026,
		96026
	],
	"./full/Transition.jpg": [
		79376,
		79376
	],
	"./full/Two-faced1.jpg": [
		73444,
		73444
	],
	"./full/Two-faced2.jpg": [
		73491,
		73491
	],
	"./full/Two-faced3.jpg": [
		1878,
		1878
	],
	"./full/Two-faced4.jpg": [
		58749,
		58749
	],
	"./full/Two-faced5.jpg": [
		33184,
		33184
	],
	"./full/Two-faced6.jpg": [
		99823,
		99823
	],
	"./full/Two-faced7.jpg": [
		39794,
		39794
	],
	"./full/Two-faced8.jpg": [
		10601,
		10601
	],
	"./full/Two-faced9.jpg": [
		55340,
		55340
	],
	"./full/Two_2006.jpg": [
		84856,
		84856
	],
	"./full/Voice1.jpg": [
		22126,
		22126
	],
	"./full/Voice2.jpg": [
		78265,
		78265
	],
	"./full/Voice3.jpg": [
		80892,
		80892
	],
	"./full/Voice4.jpg": [
		4679,
		4679
	],
	"./full/Voice5.jpg": [
		65674,
		65674
	],
	"./full/Voice6.jpg": [
		16661,
		16661
	],
	"./full/Voice7.jpg": [
		25752,
		25752
	],
	"./full/Yellowstone.jpg": [
		41326,
		41326
	],
	"./full/asparagus.jpg": [
		60080,
		60080
	],
	"./full/bells1.jpg": [
		82654,
		82654
	],
	"./full/bells2.jpg": [
		56361,
		56361
	],
	"./full/bells3.jpg": [
		10988,
		10988
	],
	"./full/bells4.jpg": [
		65335,
		65335
	],
	"./full/bells5.jpg": [
		54522,
		54522
	],
	"./full/birdPlate_1.jpg": [
		5558,
		5558
	],
	"./full/birdPlate_2.jpg": [
		81345,
		81345
	],
	"./full/birdPlate_3.jpg": [
		7748,
		7748
	],
	"./full/bird_1.png": [
		1912,
		1912
	],
	"./full/bird_2.png": [
		76403,
		76403
	],
	"./full/bird_3.png": [
		25642,
		25642
	],
	"./full/bird_4.png": [
		10309,
		10309
	],
	"./full/blue_2020.jpg": [
		26694,
		26694
	],
	"./full/body4.jpg": [
		83477,
		83477
	],
	"./full/candleholder_1.jpg": [
		21384,
		21384
	],
	"./full/candleholder_2.jpg": [
		43703,
		43703
	],
	"./full/conversation_1.jpg": [
		72112,
		72112
	],
	"./full/conversation_2.jpg": [
		55839,
		55839
	],
	"./full/conversation_3.jpg": [
		64130,
		64130
	],
	"./full/conversation_4.jpg": [
		49361,
		49361
	],
	"./full/email_at.jpg": [
		19781,
		19781
	],
	"./full/fish.jpg": [
		82355,
		82355
	],
	"./full/fish_tray_1.jpg": [
		91696,
		91696
	],
	"./full/fish_tray_2.jpg": [
		76031,
		76031
	],
	"./full/fulloptimized/2020_November.webp": [
		92979,
		92979
	],
	"./full/fulloptimized/2020_November_two.webp": [
		72266,
		72266
	],
	"./full/fulloptimized/Berta_2023.webp": [
		55002,
		55002
	],
	"./full/fulloptimized/COVER.webp": [
		51759,
		51759
	],
	"./full/fulloptimized/COVER2.webp": [
		71343,
		71343
	],
	"./full/fulloptimized/California1.webp": [
		25097,
		25097
	],
	"./full/fulloptimized/California2.webp": [
		30828,
		30828
	],
	"./full/fulloptimized/Cats1.webp": [
		87528,
		87528
	],
	"./full/fulloptimized/Cats2.webp": [
		87285,
		87285
	],
	"./full/fulloptimized/Cats3.webp": [
		83018,
		83018
	],
	"./full/fulloptimized/Cats4.webp": [
		64551,
		64551
	],
	"./full/fulloptimized/Cats5.webp": [
		1956,
		1956
	],
	"./full/fulloptimized/Cats6.webp": [
		33089,
		33089
	],
	"./full/fulloptimized/Cats7.webp": [
		57766,
		57766
	],
	"./full/fulloptimized/Cats8.webp": [
		23075,
		23075
	],
	"./full/fulloptimized/CityGirl.webp": [
		93309,
		93309
	],
	"./full/fulloptimized/CityGirl2.webp": [
		34573,
		34573
	],
	"./full/fulloptimized/CityGirl3.webp": [
		62658,
		62658
	],
	"./full/fulloptimized/CustomCat.webp": [
		91037,
		91037
	],
	"./full/fulloptimized/Emergence1.webp": [
		41644,
		41644
	],
	"./full/fulloptimized/Emergence2.webp": [
		9609,
		9609
	],
	"./full/fulloptimized/Emergence3.webp": [
		23534,
		23534
	],
	"./full/fulloptimized/Emergence4.webp": [
		73267,
		73267
	],
	"./full/fulloptimized/Emergence5.webp": [
		79184,
		79184
	],
	"./full/fulloptimized/Emergence6.webp": [
		87837,
		87837
	],
	"./full/fulloptimized/Emergence7.webp": [
		27922,
		27922
	],
	"./full/fulloptimized/FashionGirl1.webp": [
		93509,
		93509
	],
	"./full/fulloptimized/FashionGirl2.webp": [
		9112,
		9112
	],
	"./full/fulloptimized/FishStory1.webp": [
		45650,
		45650
	],
	"./full/fulloptimized/FishStory2.webp": [
		79923,
		79923
	],
	"./full/fulloptimized/FishStory3.webp": [
		70512,
		70512
	],
	"./full/fulloptimized/FishStory4.webp": [
		21833,
		21833
	],
	"./full/fulloptimized/FishStory5.webp": [
		82734,
		82734
	],
	"./full/fulloptimized/Georgia_2006.webp": [
		3037,
		3037
	],
	"./full/fulloptimized/Girl1.webp": [
		40329,
		40329
	],
	"./full/fulloptimized/Girl2.webp": [
		19660,
		19660
	],
	"./full/fulloptimized/Girl3.webp": [
		60527,
		60527
	],
	"./full/fulloptimized/Girl4.webp": [
		80498,
		80498
	],
	"./full/fulloptimized/Girl5.webp": [
		31837,
		31837
	],
	"./full/fulloptimized/IMG_0964.webp": [
		23649,
		23649
	],
	"./full/fulloptimized/IMG_0965.webp": [
		53894,
		53894
	],
	"./full/fulloptimized/IMG_0967.webp": [
		5476,
		5476
	],
	"./full/fulloptimized/IMG_0968.webp": [
		1293,
		1293
	],
	"./full/fulloptimized/IMG_0974.webp": [
		97652,
		97652
	],
	"./full/fulloptimized/IMG_0975.webp": [
		8663,
		8663
	],
	"./full/fulloptimized/Man1.webp": [
		87707,
		87707
	],
	"./full/fulloptimized/Man2.webp": [
		65338,
		65338
	],
	"./full/fulloptimized/Myth1.webp": [
		41397,
		41397
	],
	"./full/fulloptimized/Myth2.webp": [
		25288,
		25288
	],
	"./full/fulloptimized/Myth3.webp": [
		39019,
		39019
	],
	"./full/fulloptimized/Myth4.webp": [
		11878,
		11878
	],
	"./full/fulloptimized/Myth5.webp": [
		87201,
		87201
	],
	"./full/fulloptimized/Myth6.webp": [
		39716,
		39716
	],
	"./full/fulloptimized/Myth7.webp": [
		2311,
		2311
	],
	"./full/fulloptimized/Nestled_Thoughts1.webp": [
		37469,
		37469
	],
	"./full/fulloptimized/PXL_20210307.PORTRAIT.webp": [
		68211,
		68211
	],
	"./full/fulloptimized/PXL_20241009_173312640.webp": [
		78681,
		78681
	],
	"./full/fulloptimized/PXL_20241009_173400157.webp": [
		92098,
		92098
	],
	"./full/fulloptimized/PXL_20241009_173451722.webp": [
		87334,
		87334
	],
	"./full/fulloptimized/PXL_20241009_173504653.webp": [
		79358,
		79358
	],
	"./full/fulloptimized/PXL_20250426_195931697.PORTRAIT.webp": [
		9504,
		9504
	],
	"./full/fulloptimized/Provance.webp": [
		8660,
		8660
	],
	"./full/fulloptimized/Rotorua.webp": [
		88366,
		88366
	],
	"./full/fulloptimized/ScalingLife1.webp": [
		16546,
		16546
	],
	"./full/fulloptimized/ScalingLife2.webp": [
		16867,
		16867
	],
	"./full/fulloptimized/ScalingLife3.webp": [
		46816,
		46816
	],
	"./full/fulloptimized/ScalingLife4.webp": [
		85017,
		85017
	],
	"./full/fulloptimized/ScalingLife5.webp": [
		510,
		510
	],
	"./full/fulloptimized/ScalingLife6.webp": [
		12447,
		12447
	],
	"./full/fulloptimized/ScalingLife7.webp": [
		68156,
		68156
	],
	"./full/fulloptimized/Snake1.webp": [
		8823,
		8823
	],
	"./full/fulloptimized/Snake2.webp": [
		83350,
		83350
	],
	"./full/fulloptimized/Snake3.webp": [
		2225,
		2225
	],
	"./full/fulloptimized/Snake4.webp": [
		29048,
		29048
	],
	"./full/fulloptimized/Snake5.webp": [
		14395,
		14395
	],
	"./full/fulloptimized/Split1.webp": [
		38679,
		38679
	],
	"./full/fulloptimized/Split10.webp": [
		11169,
		11169
	],
	"./full/fulloptimized/Split2.webp": [
		17654,
		17654
	],
	"./full/fulloptimized/Split3.webp": [
		74929,
		74929
	],
	"./full/fulloptimized/Split4.webp": [
		66360,
		66360
	],
	"./full/fulloptimized/Split5.webp": [
		42811,
		42811
	],
	"./full/fulloptimized/Split6.webp": [
		33581,
		55962
	],
	"./full/fulloptimized/Split7.webp": [
		27461,
		27461
	],
	"./full/fulloptimized/Split8.webp": [
		69548,
		69548
	],
	"./full/fulloptimized/Split9.webp": [
		10415,
		10415
	],
	"./full/fulloptimized/Stage.webp": [
		82078,
		82078
	],
	"./full/fulloptimized/Steampunk 1.2.webp": [
		48779,
		48779
	],
	"./full/fulloptimized/Steampunk 1.6.webp": [
		85671,
		85671
	],
	"./full/fulloptimized/Steampunk 1.7.webp": [
		21636,
		21636
	],
	"./full/fulloptimized/Steampunk_1.2.webp": [
		32848,
		32848
	],
	"./full/fulloptimized/Steampunk_1.3.webp": [
		58611,
		58611
	],
	"./full/fulloptimized/Steampunk_1.4.webp": [
		45070,
		45070
	],
	"./full/fulloptimized/Steampunk_1.6.webp": [
		63500,
		63500
	],
	"./full/fulloptimized/Steampunk_1.7.webp": [
		4367,
		4367
	],
	"./full/fulloptimized/StoryKeeper1.webp": [
		60482,
		60482
	],
	"./full/fulloptimized/StoryKeeper2.webp": [
		51779,
		51779
	],
	"./full/fulloptimized/StoryKeeper3.webp": [
		21376,
		21376
	],
	"./full/fulloptimized/StoryKeeper4.webp": [
		16505,
		16505
	],
	"./full/fulloptimized/StoryKeeper5.webp": [
		75070,
		75070
	],
	"./full/fulloptimized/StoryKeeper6.webp": [
		63711,
		63711
	],
	"./full/fulloptimized/Tartu.webp": [
		43848,
		43848
	],
	"./full/fulloptimized/The_Readers_Pause.webp": [
		23729,
		23729
	],
	"./full/fulloptimized/Thea.webp": [
		48142,
		48142
	],
	"./full/fulloptimized/TinyCat1.webp": [
		11377,
		11377
	],
	"./full/fulloptimized/TinyCat2.webp": [
		33268,
		33268
	],
	"./full/fulloptimized/TinyCat3.webp": [
		17975,
		17975
	],
	"./full/fulloptimized/TinyMouse1.webp": [
		37672,
		37672
	],
	"./full/fulloptimized/TinyMouse2.webp": [
		46453,
		46453
	],
	"./full/fulloptimized/TinyMouse3.webp": [
		84586,
		84586
	],
	"./full/fulloptimized/TinyTale1.webp": [
		35585,
		35585
	],
	"./full/fulloptimized/TinyTale2.webp": [
		14948,
		14948
	],
	"./full/fulloptimized/TinyTale3.webp": [
		84999,
		84999
	],
	"./full/fulloptimized/TinyTale4.webp": [
		85514,
		85514
	],
	"./full/fulloptimized/TinyTale5.webp": [
		31029,
		31029
	],
	"./full/fulloptimized/TinyTale6.webp": [
		38600,
		38600
	],
	"./full/fulloptimized/TinyTale7.webp": [
		78507,
		78507
	],
	"./full/fulloptimized/TinyTale8.webp": [
		66686,
		66686
	],
	"./full/fulloptimized/Tits_Up1.webp": [
		31933,
		31933
	],
	"./full/fulloptimized/Tits_Up2.webp": [
		89104,
		89104
	],
	"./full/fulloptimized/Tits_Up3.webp": [
		14867,
		14867
	],
	"./full/fulloptimized/Tits_Up4.webp": [
		53230,
		53230
	],
	"./full/fulloptimized/Tits_Up5.webp": [
		49257,
		49257
	],
	"./full/fulloptimized/Transition.webp": [
		49159,
		49159
	],
	"./full/fulloptimized/Two-faced1.webp": [
		50543,
		50543
	],
	"./full/fulloptimized/Two-faced2.webp": [
		97198,
		97198
	],
	"./full/fulloptimized/Two-faced3.webp": [
		66921,
		66921
	],
	"./full/fulloptimized/Two-faced4.webp": [
		36496,
		36496
	],
	"./full/fulloptimized/Two-faced5.webp": [
		46931,
		46931
	],
	"./full/fulloptimized/Two-faced6.webp": [
		85234,
		85234
	],
	"./full/fulloptimized/Two-faced7.webp": [
		45149,
		45149
	],
	"./full/fulloptimized/Two-faced8.webp": [
		30676,
		30676
	],
	"./full/fulloptimized/Two-faced9.webp": [
		15383,
		15383
	],
	"./full/fulloptimized/Two_2006.webp": [
		18111,
		18111
	],
	"./full/fulloptimized/Voice1.webp": [
		18121,
		18121
	],
	"./full/fulloptimized/Voice2.webp": [
		81100,
		81100
	],
	"./full/fulloptimized/Voice3.webp": [
		38319,
		38319
	],
	"./full/fulloptimized/Voice4.webp": [
		58290,
		58290
	],
	"./full/fulloptimized/Voice5.webp": [
		9629,
		9629
	],
	"./full/fulloptimized/Voice6.webp": [
		66800,
		66800
	],
	"./full/fulloptimized/Voice7.webp": [
		92563,
		92563
	],
	"./full/fulloptimized/Yellowstone.webp": [
		36893,
		36893
	],
	"./full/fulloptimized/asparagus.webp": [
		11639,
		11639
	],
	"./full/fulloptimized/bells1.webp": [
		47485,
		47485
	],
	"./full/fulloptimized/bells2.webp": [
		4656,
		4656
	],
	"./full/fulloptimized/bells3.webp": [
		30419,
		30419
	],
	"./full/fulloptimized/bells4.webp": [
		16878,
		16878
	],
	"./full/fulloptimized/bells5.webp": [
		55977,
		55977
	],
	"./full/fulloptimized/blue_2020.webp": [
		87953,
		87953
	],
	"./full/fulloptimized/body4.webp": [
		1356,
		1356
	],
	"./full/fulloptimized/email_at.webp": [
		22540,
		22540
	],
	"./full/fulloptimized/fish.webp": [
		14242,
		14242
	],
	"./full/fulloptimized/harlequin.webp": [
		81501,
		81501
	],
	"./full/fulloptimized/harlequin2.webp": [
		25357,
		25357
	],
	"./full/fulloptimized/harlequin3.webp": [
		418,
		418
	],
	"./full/fulloptimized/harlequins.webp": [
		70882,
		70882
	],
	"./full/fulloptimized/headshot1.webp": [
		73049,
		73049
	],
	"./full/fulloptimized/headshot2.webp": [
		56188,
		56188
	],
	"./full/fulloptimized/headshot3.webp": [
		479,
		479
	],
	"./full/fulloptimized/headstudy1.webp": [
		34658,
		34658
	],
	"./full/fulloptimized/headstudy2.webp": [
		42307,
		42307
	],
	"./full/fulloptimized/headstudy3.webp": [
		95552,
		95552
	],
	"./full/fulloptimized/headstudy4.webp": [
		90681,
		90681
	],
	"./full/fulloptimized/house_magnets.webp": [
		79108,
		79108
	],
	"./full/fulloptimized/tailcats.webp": [
		67979,
		67979
	],
	"./full/fulloptimized/wc.webp": [
		47514,
		47514
	],
	"./full/fulloptimized/woman_in_yellow_hat.webp": [
		48131,
		48131
	],
	"./full/fulloptimized/Берта.webp": [
		368,
		368
	],
	"./full/fulloptimized/Гамаюн.webp": [
		68597,
		90978
	],
	"./full/fulloptimized/Гамаюн2.webp": [
		95868,
		95868
	],
	"./full/fulloptimized/Город.webp": [
		97621,
		97621
	],
	"./full/fulloptimized/Лиса Ах.ли.webp": [
		86290,
		86290
	],
	"./full/fulloptimized/Прованс.webp": [
		56843,
		56843
	],
	"./full/fulloptimized/Птеце_Рыб1.webp": [
		57869,
		57869
	],
	"./full/fulloptimized/Птеце_Рыб2.webp": [
		67808,
		67808
	],
	"./full/fulloptimized/Птеце_Рыб3.webp": [
		67203,
		67203
	],
	"./full/fulloptimized/Птеце_Рыб4.webp": [
		74142,
		74142
	],
	"./full/fulloptimized/Птеце_Рыб5.webp": [
		85177,
		85177
	],
	"./full/fulloptimized/Рыба 2.webp": [
		1814,
		1814
	],
	"./full/fulloptimized/Рыба.webp": [
		21956,
		21956
	],
	"./full/fulloptimized/Рыба3.webp": [
		53249,
		53249
	],
	"./full/fulloptimized/Сирень.webp": [
		63927,
		63927
	],
	"./full/fulloptimized/Сон.webp": [
		8798,
		8798
	],
	"./full/fulloptimized/Тейка.webp": [
		5442,
		5442
	],
	"./full/fulloptimized/без названия.webp": [
		91483,
		91483
	],
	"./full/fulloptimized/детство.webp": [
		28752,
		28752
	],
	"./full/fulloptimized/натюрморт  1.webp": [
		69158,
		69158
	],
	"./full/fulloptimized/натюрморт 2.webp": [
		70753,
		70753
	],
	"./full/harlequin.jpg": [
		76738,
		76738
	],
	"./full/harlequin2.jpg": [
		5122,
		5122
	],
	"./full/harlequin3.jpg": [
		25119,
		25119
	],
	"./full/harlequins.jpg": [
		64095,
		64095
	],
	"./full/headshot1.jpg": [
		59270,
		59270
	],
	"./full/headshot2.jpg": [
		17041,
		17041
	],
	"./full/headshot3.jpg": [
		3316,
		3316
	],
	"./full/headstudy1.jpg": [
		12287,
		12287
	],
	"./full/headstudy2.jpg": [
		27952,
		27952
	],
	"./full/headstudy3.jpg": [
		12525,
		12525
	],
	"./full/headstudy4.jpg": [
		31078,
		31078
	],
	"./full/horse_1.jpg": [
		92234,
		92234
	],
	"./full/horse_2.jpg": [
		67957,
		67957
	],
	"./full/horse_3.jpg": [
		63640,
		63640
	],
	"./full/horse_4.jpg": [
		26731,
		26731
	],
	"./full/horse_5.jpg": [
		48686,
		48686
	],
	"./full/horse_6.jpg": [
		28953,
		28953
	],
	"./full/horse_7.jpg": [
		42076,
		42076
	],
	"./full/horse_8.jpg": [
		69823,
		69823
	],
	"./full/house_magnets.jpg": [
		98677,
		98677
	],
	"./full/houses1.jpg": [
		82021,
		82021
	],
	"./full/houses2.jpg": [
		24794,
		24794
	],
	"./full/marbled_tray_1.jpg": [
		2553,
		2553
	],
	"./full/marbled_tray_2.jpg": [
		46414,
		46414
	],
	"./full/not_a_face1.jpg": [
		63899,
		63899
	],
	"./full/not_a_face5.jpg": [
		91799,
		91799
	],
	"./full/not_a_face6.jpg": [
		57576,
		57576
	],
	"./full/not_a_face7.jpg": [
		3589,
		3589
	],
	"./full/snake_1.jpg": [
		86641,
		86641
	],
	"./full/snake_2.jpg": [
		54438,
		54438
	],
	"./full/snake_3.jpg": [
		44547,
		44547
	],
	"./full/snake_4.jpg": [
		25744,
		25744
	],
	"./full/stoneware1.jpg": [
		16752,
		16752
	],
	"./full/stoneware2.jpg": [
		1087,
		1087
	],
	"./full/stoneware3.jpg": [
		88418,
		88418
	],
	"./full/stoneware4.jpg": [
		77649,
		77649
	],
	"./full/tailcats.jpg": [
		65024,
		65024
	],
	"./full/two_1.jpg": [
		32915,
		32915
	],
	"./full/two_2.jpg": [
		32868,
		32868
	],
	"./full/two_3.jpg": [
		10913,
		10913
	],
	"./full/wc.jpg": [
		15603,
		15603
	],
	"./full/woman_in_yellow_hat.jpg": [
		98032,
		98032
	],
	"./full/Берта.jpg": [
		41037,
		41037
	],
	"./full/Гамаюн.jpg": [
		15931,
		15931
	],
	"./full/Гамаюн2.jpg": [
		22961,
		22961
	],
	"./full/Город.jpg": [
		35790,
		35790
	],
	"./full/Лиса Ах.ли.jpg": [
		50143,
		50143
	],
	"./full/Прованс.jpg": [
		32392,
		32392
	],
	"./full/Птеце_Рыб1.jpg": [
		91538,
		91538
	],
	"./full/Птеце_Рыб2.jpg": [
		29341,
		29341
	],
	"./full/Птеце_Рыб3.jpg": [
		77600,
		77600
	],
	"./full/Птеце_Рыб4.jpg": [
		67763,
		67763
	],
	"./full/Птеце_Рыб5.jpg": [
		22998,
		22998
	],
	"./full/Рыба 2.jpg": [
		38743,
		38743
	],
	"./full/Рыба.jpg": [
		39269,
		39269
	],
	"./full/Рыба3.jpg": [
		58334,
		58334
	],
	"./full/Сирень.jpg": [
		55308,
		55308
	],
	"./full/Сон.jpg": [
		50287,
		50287
	],
	"./full/Тейка.jpg": [
		27343,
		27343
	],
	"./full/без названия.jpg": [
		20824,
		20824
	],
	"./full/детство.jpg": [
		66489,
		66489
	],
	"./full/натюрморт  1.jpg": [
		72367,
		72367
	],
	"./full/натюрморт 2.jpg": [
		23210,
		23210
	],
	"./harlequin.jpg": [
		60408,
		60408
	],
	"./harlequin.png": [
		43452,
		43452
	],
	"./harlequin2.jpg": [
		50928,
		50928
	],
	"./harlequin2.png": [
		88500,
		88500
	],
	"./harlequin3.jpg": [
		95821,
		95821
	],
	"./harlequin3.png": [
		21533,
		21533
	],
	"./harlequins.jpg": [
		15725,
		15725
	],
	"./headshot1.jpg": [
		79460,
		79460
	],
	"./headshot2.jpg": [
		73619,
		73619
	],
	"./headshot3.jpg": [
		87158,
		87158
	],
	"./headstudy1.jpg": [
		71973,
		71973
	],
	"./headstudy2.jpg": [
		84122,
		84122
	],
	"./headstudy3.jpg": [
		55287,
		55287
	],
	"./headstudy4.jpg": [
		48972,
		48972
	],
	"./horse_1.jpg": [
		19875,
		42256
	],
	"./horse_2.jpg": [
		32012,
		32012
	],
	"./horse_3.jpg": [
		95541,
		95541
	],
	"./horse_4.jpg": [
		25534,
		25534
	],
	"./horse_5.jpg": [
		8967,
		31348
	],
	"./horse_6.jpg": [
		61059,
		61059
	],
	"./horse_7.jpg": [
		48569,
		70950
	],
	"./horse_8.jpg": [
		7765,
		7765
	],
	"./house_magnets.jpg": [
		33827,
		33827
	],
	"./houses.mp4": [
		93705,
		93705
	],
	"./houses1.jpg": [
		67047,
		67047
	],
	"./houses2.jpg": [
		87064,
		87064
	],
	"./magnets.mp4": [
		67513,
		67513
	],
	"./marbled_tray_1.jpg": [
		24847,
		24847
	],
	"./marbled_tray_2.jpg": [
		11232,
		11232
	],
	"./not_a_face1.jpg": [
		3521,
		3521
	],
	"./not_a_face5.jpg": [
		34077,
		34077
	],
	"./not_a_face6.jpg": [
		79922,
		79922
	],
	"./not_a_face7.jpg": [
		56303,
		56303
	],
	"./photo.jpeg": [
		77912,
		77912
	],
	"./snake_1.jpg": [
		26783,
		26783
	],
	"./snake_2.jpg": [
		59408,
		59408
	],
	"./snake_3.jpg": [
		4301,
		4301
	],
	"./snake_4.jpg": [
		88102,
		88102
	],
	"./stoneware1.jpg": [
		21174,
		21174
	],
	"./stoneware2.jpg": [
		13313,
		13313
	],
	"./stoneware3.jpg": [
		23364,
		23364
	],
	"./stoneware4.jpg": [
		66095,
		66095
	],
	"./tailcats.jpg": [
		79554
	],
	"./taras_shevchenko_national_university_of_kyiv_logo.jpeg": [
		58846,
		58846
	],
	"./two_1.jpg": [
		95637,
		95637
	],
	"./two_2.jpg": [
		44650,
		44650
	],
	"./two_3.jpg": [
		67303,
		67303
	],
	"./wc.jpg": [
		9005,
		9005
	],
	"./wc.png": [
		34717,
		34717
	],
	"./woman_in_yellow_hat.jpg": [
		24010,
		24010
	],
	"./Берта.jpg": [
		76367,
		76367
	],
	"./Гамаюн.jpg": [
		41621,
		41621
	],
	"./Гамаюн2.jpg": [
		939,
		939
	],
	"./Город.jpg": [
		74920,
		74920
	],
	"./Лиса Ах.ли.jpg": [
		85261,
		85261
	],
	"./Прованс.jpg": [
		82810,
		82810
	],
	"./Птеце_Рыб1.jpg": [
		51704,
		51704
	],
	"./Птеце_Рыб2.jpg": [
		84551,
		84551
	],
	"./Птеце_Рыб3.jpg": [
		88746,
		88746
	],
	"./Птеце_Рыб4.jpg": [
		74489,
		74489
	],
	"./Птеце_Рыб5.jpg": [
		30140,
		30140
	],
	"./Рыба 2.jpg": [
		10449,
		10449
	],
	"./Рыба.jpg": [
		62291,
		62291
	],
	"./Рыба3.jpg": [
		9436,
		9436
	],
	"./Сирень.jpg": [
		85822,
		85822
	],
	"./Сон.jpg": [
		1505,
		1505
	],
	"./Тейка.jpg": [
		83629,
		83629
	],
	"./без названия.jpg": [
		31914,
		31914
	],
	"./детство.jpg": [
		34287,
		34287
	],
	"./натюрморт  1.jpg": [
		59089,
		59089
	],
	"./натюрморт 2.jpg": [
		10476,
		10476
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51585;
module.exports = webpackAsyncContext;